<template>
  <div class="flex p-6 flex-col overflow-auto w-full">
    <div class="w-full bg-white border border-mid-neutral-50 rounded-lg">
      <div class="space-y-2 w-full divide-y divide-mid-neutral-50">
        <OxfordLevelOfEvidencePlan />
        <AppraisalCriteria />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import OxfordLevelOfEvidencePlan from './OxfordLevelOfEvidencePlan.vue'
import AppraisalCriteria from './AppraisalCriteria.vue'
</script>
